export default "__VITE_ASSET__Ce72gISz__"